import { render, staticRenderFns } from "./pop.vue?vue&type=template&id=38e0afa5&scoped=true&"
import script from "./pop.vue?vue&type=script&lang=js&"
export * from "./pop.vue?vue&type=script&lang=js&"
import style0 from "./pop.vue?vue&type=style&index=0&lang=css&"
import style1 from "./pop.vue?vue&type=style&index=1&id=38e0afa5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e0afa5",
  null
  
)

export default component.exports